/**
 * FG — Forza gli shadow root dei web component Shopify accelerated checkout
 * a essere "open" e inietta CSS per impilare verticalmente Shop Pay / PayPal
 * solo su mobile/tablet.
 *
 * IMPORTANTE: questo file deve essere caricato come PRIMO script nel <head>
 * (sincrono, senza defer/async), prima di {{ content_for_header }}.
 * Altrimenti `<shopify-accelerated-checkout-cart>` viene montato con shadow
 * root "closed" e non riusciamo più a stilarlo dall'esterno.
 */
(function () {
  try {
    var origAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      var cfg = Object.assign({}, init || {}, { mode: 'open' });
      return origAttachShadow.call(this, cfg);
    };
  } catch (e) { /* no-op */ }

  var FG_WALLET_CSS = ''
    + '@media (max-width: 1023px){'
    + ':host{'
    +   'display:block !important;'
    +   'width:100% !important;'
    +   'box-sizing:border-box !important;'
    + '}'
    + '.wallet-cart-grid,'
    + '.accelerated-checkout-button-container{'
    +   'display:flex !important;'
    +   'flex-direction:column !important;'
    +   'align-items:stretch !important;'
    +   'justify-content:flex-start !important;'
    +   'gap:16px !important;'
    +   'width:100% !important;'
    +   'max-width:100% !important;'
    +   'margin:0 !important;'
    +   'padding:0 !important;'
    +   'box-sizing:border-box !important;'
    + '}'
    + '.wallet-cart-grid > *,'
    + '.accelerated-checkout-button-container > *{'
    +   'display:block !important;'
    +   'width:100% !important;'
    +   'max-width:100% !important;'
    +   'min-width:0 !important;'
    +   'margin:0 !important;'
    +   'padding:0 !important;'
    +   'flex:1 1 auto !important;'
    +   'box-sizing:border-box !important;'
    + '}'
    /* i singoli wallet button hanno spesso un wrapper interno con padding-inline */
    + '.wallet-cart-grid > * > *,'
    + '.accelerated-checkout-button-container > * > *{'
    +   'width:100% !important;'
    +   'max-width:100% !important;'
    +   'margin-left:0 !important;'
    +   'margin-right:0 !important;'
    +   'box-sizing:border-box !important;'
    + '}'
    + '}';

  function fgInjectWalletCss(host) {
    if (!host || !host.shadowRoot || host.__fgStacked) return;
    host.__fgStacked = true;
    try {
      var s = document.createElement('style');
      s.setAttribute('data-fg-wallet-stack', '');
      s.textContent = FG_WALLET_CSS;
      host.shadowRoot.appendChild(s);
    } catch (e) { /* no-op */ }
  }

  function fgScanWalletHosts() {
    var nodes = document.querySelectorAll(
      'shopify-accelerated-checkout-cart, shop-pay-wallet-button, shopify-paypal-button'
    );
    for (var i = 0; i < nodes.length; i++) fgInjectWalletCss(nodes[i]);
  }

  function fgStartObserver() {
    fgScanWalletHosts();
    try {
      new MutationObserver(fgScanWalletHosts).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fgStartObserver, { once: true });
  } else {
    fgStartObserver();
  }
})();
